// ==================== APPLICATION CONSTANTS ====================

export const APP_CONSTANTS = {
  // App Info
  APP_NAME: 'AmplifyMsg',
  APP_TAGLINE: 'Amplify Conversations Into Growth',
  APP_DESCRIPTION: 'A premium, cloud-first messaging automation platform that transforms conversations into measurable growth.',
  APP_VERSION: '1.0.0',
  
  // API Configuration
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080',
  API_PREFIX: import.meta.env.VITE_API_PREFIX || 'api',
  API_VERSION: import.meta.env.VITE_API_VERSION || 'v1',
  
  // Storage Keys
  STORAGE_KEYS: {
    ACCESS_TOKEN: 'amplifymsg_access_token',
    REFRESH_TOKEN: 'amplifymsg_refresh_token',
    USER: 'amplifymsg_user',
    THEME: 'amplifymsg_theme',
    SIDEBAR_COLLAPSED: 'amplifymsg_sidebar_collapsed',
  },
  
  // Pagination
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [10, 25, 50, 100],
  
  // Timeouts (in milliseconds)
  TIMEOUTS: {
    API_REQUEST: 30000,
    TOAST_DURATION: 5000,
    DEBOUNCE_SEARCH: 300,
    SESSION_CHECK: 60000,
  },
  
  // File Upload
  FILE_UPLOAD: {
    MAX_SIZE: 5 * 1024 * 1024, // 5MB
    ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
    ALLOWED_DOCUMENT_TYPES: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
  },
  
  // User Roles
  ROLES: {
    SUPER_ADMIN: 'SUPER_ADMIN',
    RESELLER: 'RESELLER',
    CUSTOMER: 'CUSTOMER',
  } as const,
  
  // Subscription Status
  SUBSCRIPTION_STATUS: {
    ACTIVE: 'ACTIVE',
    CANCELLED: 'CANCELLED',
    EXPIRED: 'EXPIRED',
    PENDING: 'PENDING',
  } as const,
  
  // Contact
  CONTACT_EMAIL: 'info@amplifymsg.com',
  CONTACT_PHONE: '+92 300 100 4001',
} as const;

// Helper to get full API URL
export const getApiUrl = (): string => {
  const { API_BASE_URL, API_PREFIX, API_VERSION } = APP_CONSTANTS;
  return `${API_BASE_URL}/${API_PREFIX}/${API_VERSION}`;
};

export type UserRole = typeof APP_CONSTANTS.ROLES[keyof typeof APP_CONSTANTS.ROLES];
export type SubscriptionStatus = typeof APP_CONSTANTS.SUBSCRIPTION_STATUS[keyof typeof APP_CONSTANTS.SUBSCRIPTION_STATUS];

